'use client';

import { useEffect } from 'react';
import { getReciteMeScript } from './utils/get-recite-me-script';

const SCRIPT_ID = 'recite-me-script';

export function useReciteMe() {
	useEffect(() => {
		if (
			process.env.NEXT_PUBLIC_RECITEME_KEY &&
			!document.getElementById(SCRIPT_ID)
		) {
			const scriptElement = document.createElement('script');
			scriptElement.id = SCRIPT_ID;
			scriptElement.type = 'text/javascript';
			scriptElement.text = getReciteMeScript(
				process.env.NEXT_PUBLIC_RECITEME_KEY,
			);
			document.body.appendChild(scriptElement);
		}
	}, []);

	const openToolbar = () => {
		if ('loadService' in window) {
			window.loadService();
		}
	};

	return { openToolbar };
}

declare global {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface Window {
		loadService: () => void;
	}
}
